import { render, staticRenderFns } from "./DeviceFailure.vue?vue&type=template&id=70c854ba&scoped=true"
import script from "./DeviceFailure.vue?vue&type=script&lang=js"
export * from "./DeviceFailure.vue?vue&type=script&lang=js"
import style0 from "./DeviceFailure.vue?vue&type=style&index=0&id=70c854ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c854ba",
  null
  
)

export default component.exports